import styled from "styled-components";
import css from "@styled-system/css";
import {
  background,
  border,
  color,
  fontSize,
  fontWeight,
  layout,
  space,
  typography,
  variant,
} from "styled-system";

import Box from "../Box/Box";
import Icon from "../Icon/Icon";
import variants from "./variants";

import { LabelProps } from "./label.type";

const StyledLabel = styled(Box)<Partial<LabelProps>>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  ${border}
  ${(props) =>
    css({
      boxShadow: props.withShadow ? "default" : "none",
      ...(props.variant === "rectangle" &&
        props.leftEdgeColor && {
          borderLeftColor: props.leftEdgeColor as string,
          borderLeftWidth: 8,
          borderLeftStyle: "solid",
        }),
    })}
  ${variant({ variants })}
  ${background}
  ${color}
  ${fontSize}
  ${fontWeight}
  ${space}
  ${layout}
  ${typography}
`;

const Label = ({
  label,
  backgroundColor = "grey-blue",
  leftEdgeColor,
  fontSize = "body-small",
  fontWeight = "medium",
  textColor = "primary-white",
  withShadow,
  variant = "rectangle",
  iconName,
  iconWeight = "regular",
  iconColor = "primary-white",
  iconWidth = 13,
  iconHeight = 13,
  iconAlignment = "right",
  ...props
}: LabelProps) => {
  return (
    <StyledLabel
      backgroundColor={backgroundColor}
      leftEdgeColor={leftEdgeColor}
      color={textColor as string}
      fontSize={fontSize}
      fontWeight={fontWeight}
      withShadow={withShadow}
      variant={variant}
      {...props}
    >
      {iconName && iconAlignment === "left" && (
        <Icon
          name={iconName}
          weight={iconWeight}
          color={iconColor}
          width={iconWidth}
          height={iconHeight}
          mr={1}
        />
      )}
      {label}
      {iconName && iconAlignment === "right" && (
        <Icon
          name={iconName}
          weight={iconWeight}
          color={iconColor}
          width={iconWidth}
          height={iconHeight}
          ml={1}
        />
      )}
    </StyledLabel>
  );
};

export default Label;
